module.exports = __webpack_public_path__ + "img/gallery-5.3615971a.jpg";